import * as _ from 'lodash';
import Validator from 'validatorjs';
import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import TipoAportacionODepositoOptions from '../../../support/catalogos/planesderetiro/TipoAportacionODepositoOptions';
import AportacionesODepositosRules from '../../../support/rules/complementos/planesderetiro/AportacionesODepositosRules';

const AportacionesODepositosForm = (props) => {

  const [state, setState] = useState({
    data: {},
    validator: new Validator({}, AportacionesODepositosRules()),
    isValid: false
  });

  const { data: editing } = props;
  const { data, isValid } = state;
  const rules = AportacionesODepositosRules(data);

  const handleOnChange = (event) => {
    const newState = {
      ...state,
      data: {
        ...state.data,
        ...event,
      }
    }

    setState(newState);
  };

  const validate = (data) => {
    let passes = false;
    const validator = new Validator(data, rules);

    if (!_.isEmpty(data)) {
      passes = validator.passes()
    }

    const newState = {
      ...state,
      validator: validator,
      isValid: passes
    }

    setState(newState);
  };

  useEffect(() => {
    validate(data);
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!!editing && !!editing.id) {
      setState({
        ...state,
        data: {...editing}
      });
    }
  }, [editing]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleOnAdd = () => {
    props.onAdd(data);

    clearState();
  }

  const clearState = () => {
    setState({
      ...state,
      data: {}
    });
  }

  return (
    <>
      <h5 className="text-right">Aportaciones o Depósito</h5>

      <Row>
      <Col sm md={ 12 }>
          <FormControl type="select"
            label="Tipo de aportación o depósito"
            name="TipoAportacionODeposito"
            placeholder=""
            help=""
            rules={ rules.TipoAportacionODeposito }
            value={ data.TipoAportacionODeposito }
            options={ TipoAportacionODepositoOptions }
            onChange={ handleOnChange }
          />
        </Col>
      </Row>

      <Row>
        <Col sm md={ 6 }>
          <FormControl type="number"
            label="Monto aportacion o depósito"
            name="MontAportODep"
            placeholder=""
            help=""
            rules={ rules.MontAportODep }
            value={ data.MontAportODep }
            onChange={ handleOnChange }
          />
        </Col>

        <Col sm md={ 6 }>
          <FormControl type="text"
            label="RFC Fiduciaria"
            name="RFCFiduciaria"
            placeholder=""
            help=""
            minLength="12"
            maxLength="13"
            rules={ rules.RFCFiduciaria }
            value={ data.RFCFiduciaria }
            onChange={ handleOnChange }
          />
        </Col>

      </Row>

      <Row>
        <Col className="text-right pb-2">
          <Button variant="secondary"
            disabled={ !isValid }
            onClick={ handleOnAdd }
          >
            Agregar Aportaciones O Depósitos
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default AportacionesODepositosForm;
